module.exports = __webpack_public_path__ + "static/img/img-textcloud.c565621.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/img-textcloud.png
// module id = jlsy
// module chunks = 1